import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PageSection from '../../components/Layout/Content/PageSection';
import Filters from './Filters';
import Table from './Table';
import Overview from './Overview';
import { selectValues } from './utils';
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';
import OBJCODE from '../../constants';
import sortOnlyOneOfEachProject from '../../utils/filterTasksOrProjects';
import { Wrap } from './styles';

const Calendar = ({ user }) => {
  const [tasks, setTasks] = useState([]);

  const [viewOptions, setViewOptions] = useState({
    isLoading: true,
    elements: [],
    selected: 7,
  });

  const [startDate, setStartDate] = useState(new Date());

  const [possibleStatus, setPossibleStatus] = useState();

  const fetchTasks = async () => {
    const fields = [
      'project:name',
      'project:plannedStartDate',
      'project:plannedCompletionDate',
      'project:percentComplete',
      'project:status',
      'project:allStatuses',
      'project:program',
      'project:portfolio',
      'percentComplete',
      'plannedStartDate',
      'plannedCompletionDate',
      'status',
      'allStatuses',
    ];
    const queryParams = {
      'assignments:assignedToID': user,
      parentID_Mod: 'notblank',
      'project:status': 'CUR',
    };
    const response = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK_SEARCH, queryParams, fields },
    );
    setTasks(response);
  };

  async function getTasksStatus() {
    const actionResponse = await actionWebInvoke(
      actions['workfront-action'],
      {},
      { objCode: OBJCODE.TASK_METADATA },
    );

    return setPossibleStatus(actionResponse.fields.status.possibleValues);
  }

  const handleDateChange = alterDate => {
    const periodToAlter = viewOptions.selected === 7 ? 'day' : 'month';

    return alterDate === 'add'
      ? setStartDate(moment(startDate).add(1, periodToAlter).toDate())
      : setStartDate(moment(startDate).subtract(1, periodToAlter).toDate());
  };

  useEffect(() => {
    setViewOptions({ ...viewOptions, elements: selectValues.viewOptions });
    if (user.length > 0) {
      fetchTasks();
      getTasksStatus();
    }
  }, [user]);

  const uniqueProjectNames = sortOnlyOneOfEachProject(tasks);

  return (
    <Wrap>
      <PageSection title="Calendar">
        <Filters
          viewOptions={viewOptions}
          setViewOptions={setViewOptions}
          startDate={startDate}
          setStartDate={setStartDate}
          handleDateChange={handleDateChange}
        />
        <Table
          viewBy={viewOptions.selected}
          possibleStatus={possibleStatus}
          projects={uniqueProjectNames}
          startDate={startDate}
          setStartDate={setStartDate}
        />
      </PageSection>

      {tasks && <Overview tasks={tasks} />}
    </Wrap>
  );
};

Calendar.propTypes = {
  user: PropTypes.string,
};

Calendar.defaultProps = {
  user: '',
};

export default Calendar;
